(function () {
  "use strict";

  const SELECTORS = {
    viewport: "[data-variant-pills]",
  };

  const MOBILE_BREAKPOINT = 1024;

  const MAX_POLL_ATTEMPTS = 100;

  const waitForDependencies = () =>
    new Promise((resolve, reject) => {
      let attempts = 0;
      const check = () => {
        if (
          typeof EmblaCarousel !== "undefined" &&
          typeof EmblaCarouselAutoScroll !== "undefined"
        ) {
          resolve();
        } else if (attempts >= MAX_POLL_ATTEMPTS) {
          reject(new Error("Embla dependencies failed to load"));
        } else {
          attempts += 1;
          setTimeout(check, 50);
        }
      };
      check();
    });

  const isOverflowing = (viewport) => {
    const container = viewport.firstElementChild;
    return container.scrollWidth > viewport.clientWidth;
  };

  const duplicateSlides = (container) => {
    const slides = Array.from(container.children);
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      container.appendChild(clone);
    });
  };

  const initCarousel = async (viewport) => {
    if (!isOverflowing(viewport)) return;

    try {
      await waitForDependencies();
    } catch (_) {
      return;
    }

    const container = viewport.firstElementChild;
    duplicateSlides(container);

    const autoScroll = EmblaCarouselAutoScroll({
      speed: 0.5,
      startDelay: 500,
      playOnInit: true,
      stopOnInteraction: false,
      stopOnFocusIn: false,
      stopOnMouseEnter: false,
    });

    EmblaCarousel(
      viewport,
      {
        loop: true,
        align: "start",
        dragFree: true,
      },
      [autoScroll],
    );
  };

  const init = () => {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;

    document.querySelectorAll(SELECTORS.viewport).forEach(initCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
